import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-location',
  templateUrl: './menu-location.component.html',
  styleUrls: ['./menu-location.component.scss']
})
export class MenuLocationComponent {

}
